(() => {
  const sectionSelector = '[data-thom-review-carousel]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function cardsPerPage() {
    if (window.innerWidth >= 990) return 3;
    return 1;
  }

  function initSection(section) {
    if (!section || section.dataset.thomReviewCarouselReady === 'true') return;

    const viewport = section.querySelector('[data-thom-review-viewport]');
    const cards = Array.from(section.querySelectorAll('[data-thom-review-card]'));
    const previous = section.querySelector('[data-thom-review-prev]');
    const next = section.querySelector('[data-thom-review-next]');
    const pagination = section.querySelector('[data-thom-review-pagination]');
    const status = section.querySelector('[data-thom-review-status]');

    if (!viewport || !cards.length || !previous || !next || !pagination) return;

    section.dataset.thomReviewCarouselReady = 'true';
    let page = 0;
    let pageCount = 1;
    let perPage = 1;

    function renderPagination() {
      pagination.replaceChildren();

      for (let index = 0; index < pageCount; index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'thom-home-reviews__dot';
        dot.setAttribute('aria-label', `Show review page ${index + 1}`);
        dot.setAttribute('aria-current', index === page ? 'true' : 'false');
        dot.addEventListener('click', () => goToPage(index, true));
        pagination.append(dot);
      }
    }

    function updateControls(announce = false) {
      previous.disabled = page === 0;
      next.disabled = page >= pageCount - 1;
      Array.from(pagination.children).forEach((dot, index) => {
        dot.setAttribute('aria-current', index === page ? 'true' : 'false');
      });

      if (announce && status) {
        status.textContent = `Review page ${page + 1} of ${pageCount}.`;
      }
    }

    function goToPage(nextPage, announce = false) {
      page = Math.max(0, Math.min(nextPage, pageCount - 1));
      const firstCard = cards[page * perPage];

      if (firstCard) {
        viewport.scrollTo({
          left: firstCard.offsetLeft,
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
        });
      }

      updateControls(announce);
    }

    function measure() {
      const nextPerPage = cardsPerPage();
      const firstVisibleIndex = page * perPage;
      perPage = nextPerPage;
      pageCount = Math.max(1, Math.ceil(cards.length / perPage));
      page = Math.min(Math.floor(firstVisibleIndex / perPage), pageCount - 1);
      renderPagination();
      goToPage(page);
    }

    previous.addEventListener('click', () => goToPage(page - 1, true));
    next.addEventListener('click', () => goToPage(page + 1, true));

    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(viewport);
    measure();
  }

  function initAll(root = document) {
    root.querySelectorAll(sectionSelector).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
